export interface QAData {
  question: string;
  answer: string;
}

export const dogQAItems: QAData[] = [
  {
    question: 'Welches Nassfutter ist für empfindliche Mägen geeignet?',
    answer:
      'Wähle ein Nassfutter mit leicht verdaulichen Zutaten wie unsere Belly Balance Produkte oder das Nassfutter Classic Huhn, Wildschwein oder Pute.',
  },
  {
    question: 'Welches Futter bei Unverträglichkeiten oder Allergien?',
    answer:
      'Hypoallergenes Nassfutter mit begrenzten Zutaten. Unsere Hypocare Produkte sind speziell auf die Bedürfnisse von Allergikern und Hunden mit Unverträglichkeiten abgestimmt.',
  },
  {
    question:
      'Mein Hund frisst nur sehr wählerisch. Wie finde ich das richtige Futter?',
    answer:
      'Unsere Nass- und Trockenfutter so wie unsere BARF Menus sind speziell auf die Bedürfnisse wählerischer Hunde abgestimmt. Dank unserer schonenden Zubereitung und hochwertigen Zutaten wie viel frischem Fleisch / Fisch und knackigem Gemüse liefern sie einen unwiderstehlichen Geschmack. 8 von 10 Hunden lieben es.',
  },
  {
    question: 'Wie viel Futter benötigt mein Hund pro Tag?',
    answer:
      'Orientiere dich an den Fütterungsempfehlungen auf der Verpackung oder hier auf der Website. welche du unter "Fütterungsempfehlung" findest. Die Menge basiert stehts auf Alter, Gewicht und Aktivität und kann sich über die Zeit verändern.',
  },
  {
    question:
      'Mein Hund ist übergewichtig. Gibt es Nassfutter, das beim Abnehmen hilft?',
    answer:
      'Wähle ein kalorienreduziertes Nassfutter mit hohem Protein- und Ballaststoffgehalt, um den Hund satt zu halten. Hier empfehlen sich unsere Nassfutterprodukte Huhn, Lachs & Pute sowie unser Trockenfutter mit Huhn oder Fisch.',
  },
];

export const catQAItems: QAData[] = [
  {
    question:
      'Mine Katze ist sehr wählerisch. Wie finde ich das richtige Nassfutter?',
    answer:
      "Testen verschiedene Geschmacksrichtungen, Konsistenzen. Manche Katzen bevorzugen Paté oder Filet, andere Soße. Unsere Saucen Menus und Meaty Patés sind der absolute Akzeptanzknaller. Dank unserer Lecker-Garantie kannst du bedenkenlos bestellen. Wenn's nicht schmeckt, gibt's Geld zurück-",
  },
  {
    question:
      'Meine Katze leidet häufig an Durchfall oder Erbrechen. Welches Nassfutter hilft?',
    answer:
      'Wähle leicht verdauliche Sorten mit hochwertigen Proteinen hier kommen alle unsere Nassfutter mit Huhn oder Fisch infrage.',
  },
  {
    question:
      'Meine Katze hat Allergien. Gibt es Nassfutter ohne häufige Allergene?',
    answer:
      'Ja, wähle hypoallergenes Futter mit begrenzten Zutaten und exotischen Proteinen wie Känguru oder Ente.',
  },
  {
    question: 'Wie viel Nassfutter braucht meine Katze täglich?',
    answer:
      'Die Menge hängt vom Gewicht, Alter und Aktivitätslevel ab. Orientiere dich an den Angaben auf der Verpackung oder hier auf der Website unter "Fütterungsempfehlung"',
  },
  {
    question: 'Meine Katze hat Übergewicht. Welches Nassfutter eignet sich?',
    answer:
      'Wählen Sie kalorienarmes Nassfutter mit hohem Proteingehalt und geringem Fettgehalt, um den Muskelaufbau zu unterstützen. Hier kannst du zu all unseren Nassfuttern mit der Sorte Huhn oder Pute greifen.',
  },
];
